import Image from 'next/image'
import { cn } from '@/utils/styles/cn'

interface IFadeOverlayProps {
    className?: string
    imageClassName?: string
    style?: React.CSSProperties
    width?: number
    height?: number
}

export const FadeOverlay = ({
    className,
    imageClassName,
    width = 393,
    height = 220,
    style,
}: IFadeOverlayProps) => {
    return (
        <div
            style={{ aspectRatio: width / height, ...style }}
            className={cn('w-full flex justify-end pointer-events-none', className)}
        >
            <Image
                priority
                alt="Fade overlay"
                src="/_images/meta/fade.svg"
                height={height}
                width={width}
                className={cn('w-full object-cover', imageClassName)}
            />
        </div>
    )
}
